import script from "./FooterRefi.vue?vue&type=script&setup=true&lang=ts"
export * from "./FooterRefi.vue?vue&type=script&setup=true&lang=ts"

import "./FooterRefi.vue?vue&type=style&index=0&id=6023ef74&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6023ef74"]])

export default __exports__